import AuthService from "./auth.service";
import AccountService from "./account.service";
import PasswordHistoryService from "./passwordHistory.service";
import StoreService from "./store.service";
import ChainService from "./chain.service";
import TaskService from "./task.service";
import SelectStoreService from "./selectStore.service";
import HelpService from "./help.service";
import DownloadService from "./download.service";
import NotifyService from "./notify.service";
import DashboardService from "./dashboard.service";
import UploadService from "./upload.service";
import GanttChartService from "./ganttChart.service";
import OTAService from "./ota.service";
import PlanAmountService from "./planAmount.service";
import ContentService from "@iso/services/content.service";
import ContentAchievementService from "@iso/services/contentAchievementService.service";
import CrawlPlanSaleService from "@iso/services/crawlPlanSale.service";
import TaskCopyHistoryService from "@iso/services/taskCopyHistory.service"
import TaskStoreConfigService from "@iso/services/taskStoreConfig.service"
import AggregateService from "./aggregate.service";
import CrawlCouponService from "@iso/services/crawlCoupon.service"
import CrawlSaleStatisticService from "@iso/services/crawlSaleStatistic.service";
import RequestTimeService from "@iso/services/requestTime.service"
import TotalTimeWorkService from "@iso/services/totalTimeWork.service"
import TimesheetService from "@iso/services/timesheet.service"
import ResourceSheetService from "@iso/services/resourceSheet.service"
import ResourceDashboardService from "@iso/services/resourceDashboard.service"
import CrawlPrinceAchievementService from "@iso/services/crawlPrinceAchievement.service"
import TemplateService from "@iso/services/template.service";
import AutoCopyTaskService from "@iso/services/autoCopyTask.service";
import CrawlingSettingService from "@iso/services/crawlingSetting.service";
import ReviewCrawlingSettingService from "@iso/services/reviewCrawlingSetting.service";
import TllBulkReservationSettingService from "@iso/services/tllBulkReservationSetting.service";
import RakutenScoringSettingService from "@iso/services/rakutenScoringSetting.service";
import SlackMeetingStoreMappingService from "@iso/services/slackMeetingStoreMapping.service";
import GalleryContentService from "@iso/services/galleryContent.service";
import ProposalSlideSettingService from "@iso/services/proposalSlideSetting.service";
import FacilityCredentialService from "@iso/services/facilityCredential.service";
import ApiPlanOtaService from "@iso/services/apiPlanOta.service";
import SelectApiRoomService from "./selectApiRoom.service";
import ApiRoomService from "@iso/services/apiRoom.service"
import ApiImageCategoryService from "@iso/services/apiImageCategory.service";
import ApiImageService from "@iso/services/apiImageservice";
import ApiOptionValuesService from "@iso/services/apiOptionValues.service";
import ApiCrawlRoomService from "@iso/services/apiCrawlRoom.service";
import ApiCrawlPlanService from "@iso/services/apiCrawlPlan.service";
import ApiCancelPolicyService from "@iso/services/apiCancelPolicy.service";
import CrawlVisitorToHennaHotelService from "@iso/services/crawlVisitorToHennaHotel.service";
import TwoFactorAuthenticationService from "@iso/services/twoFactorAuthentication.service";
import CrawlAdditionalRequestService from "@iso/services/crawlAdditionalRequest.service";
import ApiCrawlOptionService from "@iso/services/apiCrawlOption.service";
import CrawlDataCollectionService from "@iso/services/crawlDataCollection.service";
import CrawlRankingAndScoreService from "@iso/services/crawlRankingAndScore.service";
import TeamService from "@iso/services/team.service";
import CrawlBookingPositionService from "@iso/services/crawlBookingPosition.service";
import CrawlDomesticIndicatorService from "@iso/services/crawlDomesticIndicator.service";
import CrawlExtractSellingPriceService from "@iso/services/crawlExtractSellingPrice.service";
import teamSettingsService from "./teamSettings.service";
import CategoryService from "@iso/services/category.service";
import TaskStatusService from "@iso/services/taskStatus.service";
import AiCheckHistoryService from "@iso/services/aiCheckHistory.service";
import AiCheckKnowledgeService from "@iso/services/aiCheckKnowledge.service";
import ExportedContentsService from "@iso/services/exportedContents.service";

export const authService = new AuthService({});
export const accountService = new AccountService({});
export const chainService = new ChainService({});
export const passwordHistoryService = new PasswordHistoryService({});
export const storeService = new StoreService({});
export const taskService = new TaskService({});
export const selectStoreService = new SelectStoreService({});
export const helpService = new HelpService({});
export const downloadService = new DownloadService({});
export const notifyService = new NotifyService({});
export const dashboardService = new DashboardService({});
export const uploadService = new UploadService({});
export const ganttChartService = new GanttChartService({});
export const otaService = new OTAService({});
export const planAmountService = new PlanAmountService({});
export const contentService = new ContentService({});
export const contentAchievementService = new ContentAchievementService({});
export const taskCopyHistoryService = new TaskCopyHistoryService({});
export const taskStoreConfigService = new TaskStoreConfigService({});
export const aggregateService = new AggregateService({});
export const crawlPlanSaleService = new CrawlPlanSaleService({});
export const crawlCouponService = new CrawlCouponService({});
export const crawlSaleStatisticService = new CrawlSaleStatisticService({});
export const requestTimeService = new RequestTimeService({});
export const totalTimeWorkService = new TotalTimeWorkService({});
export const timesheetService = new TimesheetService({});
export const resourceSheetService = new ResourceSheetService({});
export const resourceDashboardService = new ResourceDashboardService({});
export const crawlPrinceAchievementService = new CrawlPrinceAchievementService({});
export const templateService = new TemplateService({});
export const autoCopyTaskService = new AutoCopyTaskService({});
export const crawlingSettingService = new CrawlingSettingService({});
export const reviewCrawlingSettingService = new ReviewCrawlingSettingService({});
export const tllBulkReservationSettingService = new TllBulkReservationSettingService({});
export const rakutenScoringSettingService = new RakutenScoringSettingService({});
export const slackMeetingStoreMappingService = new SlackMeetingStoreMappingService({});
export const galleryContentService = new GalleryContentService({});
export const proposalSlideSettingService = new ProposalSlideSettingService({});
export const facilityCredentialService = new FacilityCredentialService({});
export const apiPlanOtaService = new ApiPlanOtaService({});
export const selectApiRoomService = new SelectApiRoomService({});
export const apiRoomService = new ApiRoomService({});
export const apiImageCategoryService = new ApiImageCategoryService({});
export const apiImageService = new ApiImageService({});
export const apiOptionValuesService = new ApiOptionValuesService({});
export const apiCrawlRoomService = new ApiCrawlRoomService({});
export const apiCrawlPlanService = new ApiCrawlPlanService({});
export const apiCancelPolicyService = new ApiCancelPolicyService({});
export const crawlVisitorToHennaHotelService = new CrawlVisitorToHennaHotelService({});
export const twoFactorAuthenticationService = new TwoFactorAuthenticationService({});
export const crawlAdditionalRequestService = new CrawlAdditionalRequestService({});
export const apiCrawlOptionService = new ApiCrawlOptionService({});
export const crawlDataCollectionService = new CrawlDataCollectionService({});
export const crawlRankingAndScoreService = new CrawlRankingAndScoreService({});
export const teamService = new TeamService({});
export const crawlBookingPositionService = new CrawlBookingPositionService({});
export const crawlDomesticIndicatorService = new CrawlDomesticIndicatorService({});
export const crawlExtractSellingPriceService = new CrawlExtractSellingPriceService({});
export { teamSettingsService };
export const categoryService = new CategoryService({});
export const taskStatusService = new TaskStatusService({});
export const aiCheckHistoryService = new AiCheckHistoryService({});
export const aiCheckKnowledgeService = new AiCheckKnowledgeService({});
export const exportedContentsService = new ExportedContentsService({});